// because Fetch doesn't recognize error responses as
// actual errors since it's technically completing the response...
export function handleApiErrors (xhr, history) {
  if (xhr.data) {
    if (xhr.data.code === 401 || xhr.data.code === 403) {
      if (history) {
        return history.push('/login');
      }
      else {
        return xhr;
      }
    }
    else if (xhr.data.code === 413) {
      if (history) {
        return history.push('/403');
      }
      else {
        throw {code: xhr.data.code, message: xhr.data.error};
      }
    }
    else if (xhr.data.code && xhr.data.code == 500) {
      throw xhr.data.message || xhr.data.error || "Lỗi trong quá trình tải dữ liệu";
    }
  }

  return xhr
}

export function handleErrors (errorApi, history) {
  const errStr = errorApi.toString()
  if (errStr.indexOf('Request failed with status code 500') > -1) {
    throw 'Lỗi kết nối, xin hãy thử lại';
  }
  if (!errorApi.response)
  {
    if (errorApi.message && errorApi.message.indexOf('Network Error') > -1)
    {
      if (history) {
        return history.push('/login');
      }
      else {
        throw 'Lỗi kết nối, xin hãy thử lại';
      }
    }
    else 
    {
      throw errorApi;
    }
  }
  
  switch(errorApi.response.status){
    case 401:
      history.push('/login');
      break;
    default:
      throw errorApi;
  }
}


// WEBPACK FOOTER //
// ./src/lib/api-errors.js